import React from 'react';
import { PROCEDURES } from '../../constants/procedures';

function ProcedureSelector({ value, onChange, error }) {
  return (
    <div className="procedure-selector">
      <label className="image-upload-label">Select Procedure</label>
      <div className="procedure-grid" role="listbox" aria-label="Cosmetic procedures">
        {PROCEDURES.map(({ id, label }) => {
          const isSelected = value === id;
          return (
            <button
              key={id}
              type="button"
              role="option"
              aria-selected={isSelected}
              className={`procedure-card${isSelected ? ' selected' : ''}`}
              onClick={() => onChange(id)}
            >
              <span className="procedure-card-label">{label}</span>
            </button>
          );
        })}
      </div>
      {error && <span className="image-upload-error">{error}</span>}
    </div>
  );
}

export default ProcedureSelector;
